import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

type ClickableBoxProps = {
  onClick?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  children: React.ReactNode;
  sx?: BoxProps["sx"];
  disabled?: boolean;
  tooltipText?: string;
};

const ClickableBox: React.FC<ClickableBoxProps> = ({ onClick, children, sx, disabled = false, tooltipText }) => {
  return (
    <Tooltip title={tooltipText || ""} disableHoverListener={!tooltipText || disabled}>
      <Box
        role={disabled ? undefined : "button"}
        tabIndex={disabled ? -1 : 0}
        onClick={disabled ? undefined : onClick}
        onKeyDown={
          disabled
            ? undefined
            : (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onClick?.(e);
                }
              }
        }
        sx={[
          {
            userSelect: "none",
            transition: (theme) =>
              theme.transitions.create(["background-color"], {
                duration: theme.transitions.duration.short,
              }),
            ...(disabled
              ? {
                  cursor: "default",
                  "&:hover": { bgcolor: "transparent" },
                  "&:active": { bgcolor: "transparent" },
                }
              : {
                  cursor: "pointer",
                  "&:hover": { bgcolor: "action.hover" },
                  "&:active": { bgcolor: "action.selected" },
                }),
            width: "fit-content",
            pr: 1
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default ClickableBox;
